import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.25C6.615 2.25 2.25 6.615 2.25 12C2.25 17.385 6.615 21.75 12 21.75C17.385 21.75 21.75 17.385 21.75 12C21.75 6.615 17.385 2.25 12 2.25ZM13.8245 5.77226C13.7842 5.67649 13.7129 5.59699 13.6221 5.54644C13.5314 5.49588 13.4263 5.47714 13.3237 5.49321C13.2211 5.50929 13.1268 5.55925 13.0559 5.63513L6.54371 12.6124C6.48183 12.6787 6.44065 12.7616 6.42523 12.8509C6.40982 12.9402 6.42084 13.0321 6.45695 13.1153C6.49305 13.1984 6.55267 13.2692 6.62846 13.3189C6.70426 13.3686 6.79293 13.3951 6.88358 13.3951H11.3912L10.1558 17.9239C10.1282 18.0242 10.135 18.1309 10.1753 18.2269C10.2155 18.3229 10.2867 18.4027 10.3776 18.4534C10.4685 18.5041 10.5737 18.5229 10.6765 18.5067C10.7793 18.4906 10.8738 18.4404 10.9447 18.3642L17.4568 11.3869C17.5187 11.3207 17.5599 11.2378 17.5753 11.1485C17.5907 11.0591 17.5797 10.9672 17.5436 10.8841C17.5075 10.801 17.4479 10.7302 17.3721 10.6804C17.2963 10.6307 17.2076 10.6042 17.117 10.6042H12.6093L13.8448 6.07486C13.872 5.97456 13.8649 5.86803 13.8245 5.77226Z"
        fill={colorValue}
      />
    </svg>
  );
};
